import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';

// Chart.js 기본 요소 등록
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const NewMonthMultiAxisLineChart = ({list}) => {

    // 각 월별 초기값 0으로 세팅
    const salesData = Array(12).fill(0);
    const orderCountData = Array(12).fill(0);
    const cancelData = Array(12).fill(0);

// list의 데이터를 salesData, orderCountData, cancelData에 삽입
    list.forEach(item => {
        const monthIndex = item.month - 1; // 월 값에 맞춰 인덱스 설정
        salesData[monthIndex] = item.totalSalesAmount || 0;
        orderCountData[monthIndex] = item.completeOrderCount || 0;
        cancelData[monthIndex] = item.cancelOrderCount || 0;
    });

    // 데이터 설정
    const data = {
        labels: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
        datasets: [
            {
                label: '총 매출액',
                data: salesData,
                borderColor: 'rgba(0, 204, 204, 1)',
                backgroundColor: 'rgba(0, 204, 204, 1)',
                yAxisID: 'y', // 왼쪽 축
            },
            {
                label: '총 주문건수',
                data: orderCountData,
                borderColor: 'rgba(0, 146, 255, 1)',
                backgroundColor: 'rgba(0, 146, 255, 1)',
                yAxisID: 'y1', // 오른쪽 축
            },
            {
                label: '주문취소',
                data: cancelData,
                borderColor: 'rgba(51, 51, 51, 0)',
                backgroundColor: 'rgba(51, 51, 51, 0)'
            }
        ]
    };

    // 옵션 설정
    const options = {
        responsive: true,
        maintainAspectRatio: false,
        interaction: {
            mode: 'index',
            intersect: false,
        },
        stacked: false,
        plugins: {
            legend: {
                display: false
            },
            title: {
                display: false
            },
        },
        scales: {
            y: {
                type: 'linear',
                display: true,
                position: 'left',
                min: 0,
                max: 1000000,
                ticks: {
                    callback: function(value) {
                        return value / 10000 + '만'; // 백만 단위로 포맷
                    },
                    stepSize:100000,
                    maxTicksLimit: 11
                },
            },
            y1: {
                type: 'linear',
                display: true,
                position: 'right',
                min: 0,
                max: 500,
                grid: {
                    drawOnChartArea: false, // 왼쪽 축의 그리드와 구분
                },
                ticks: {
                    callback: function(value) {
                        return value + '건'; // 백만 단위로 포맷
                    },
                    stepSize:50,
                    maxTicksLimit: 11
                },
            },
        },
    };

    return <Line data={data} options={options} />;
};

export default NewMonthMultiAxisLineChart;
